import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimTypeDealerGroupAutomationRule.Delete.IRequest;
type Response = Api.Core.ClaimTypeDealerGroupAutomationRule.Delete.IResponse;
type Headers = Api.Core.ClaimTypeDealerGroupAutomationRule.Delete.IHeaders;
const deleteApiClaimTypeDealerGroupAutomationRulePath = '/api/DealerManagement/ClaimTypeDealerGroupAutomationRule/:id';
export default async function claimTypeDealerGroupAutomationRuleDeleteApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(deleteApiClaimTypeDealerGroupAutomationRulePath, params),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
